import { isCdm, isOcf, isPp } from "features/cdm/constants/reviewTypes";

// The programme a review belongs to (CDM / PP / OCF), or null for others
// (e.g. deregistration).
export const getProgrammeForReviewType = (reviewType) => {
  if (isCdm(reviewType)) return "CDM";
  if (isPp(reviewType)) return "PP";
  if (isOcf(reviewType)) return "OCF";
  return null;
};

// { CDM: { id, date }, PP: {...}, OCF: {...} } — the most recent review per
// programme, used to mark which preview is the latest (editable) one.
export const getMostRecentReviewIdByProgramme = (reviewHistory = []) => {
  const latest = {};

  reviewHistory.forEach((review) => {
    const programme = getProgrammeForReviewType(review.reviewType);
    if (!programme) return;

    const reviewDate = new Date(review.reviewDate ?? review.date);
    const current = latest[programme];

    if (!current || reviewDate > current.date) {
      latest[programme] = { id: review.id, date: reviewDate };
    }
  });

  return latest;
};
